<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-switch
                v-model="settingValue"
                :true-value="true"
                :false-value="false"
                :label="$language.translate(title)"
            />
        </v-flex>
        <v-flex xs12>
            {{ description | translation }}
        </v-flex>
        <v-flex xs12>
            <v-divider />
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    props: {
        title: String,
        description: String,
        value: Boolean,
        stateKey: String,
    },
    computed: {
        settingValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('onSettingChange', { key: this.stateKey, value: value });
            }
        }
    },
};
</script>
